import { createCardSwipe } from './card-swipe.js';

const SWIPE_SETUP_ERROR_MESSAGE = 'The card reader could not be set up, please refresh the page to swipe a card.';
const SWIPE_CANCELLED = 'cancelled';
const bindings = new WeakMap();

function unbindCardSwipeButton(button, wrap) {
    bindings.get(button)?.abort();
    bindings.delete(button);
    button.disabled = false;
    wrap.hidden = true;
}

function bindCardSwipeButton({ wrap, button, gatewayJavascriptUrl, gatewayApi, onSwipe, onError }) {
    unbindCardSwipeButton(button, wrap);
    if (!gatewayJavascriptUrl || !gatewayApi) {
        return Promise.resolve(false);
    }

    const controller = new AbortController();
    bindings.set(button, controller);

    return createCardSwipe(gatewayJavascriptUrl, gatewayApi)
        .then((swipe) => {
            if (controller.signal.aborted) {
                return false;
            }
            wrap.hidden = false;
            button.addEventListener('click', async () => {
                button.disabled = true;
                try {
                    onSwipe(await swipe.getSwipe());
                } catch (err) {
                    if (err !== SWIPE_CANCELLED) {
                        onError(String(err));
                    }
                } finally {
                    button.disabled = false;
                }
            }, { signal: controller.signal });
            return true;
        })
        .catch(() => {
            if (!controller.signal.aborted) {
                button.disabled = true;
                onError(SWIPE_SETUP_ERROR_MESSAGE);
            }
            return false;
        });
}

export { bindCardSwipeButton, unbindCardSwipeButton };
